import { render, staticRenderFns } from "./ApplyToBackgroundColor.vue?vue&type=template&id=1a6330b6"
import script from "./ApplyToBackgroundColor.vue?vue&type=script&lang=js"
export * from "./ApplyToBackgroundColor.vue?vue&type=script&lang=js"
import style0 from "./ApplyToBackgroundColor.vue?vue&type=style&index=0&id=1a6330b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports